import React from 'react'
import format from '@st-operations/uikit/lib/format'
import { Icon, ProgressBar } from '@st-operations/uikit/src/v2'

import twoNonZeroDecimals from '_lib/twoNonZeroDecimals'

import './styles.scss'

const MonthlyUserCount = ({ totalUsers }) => {
  return (
    <div className="de-wizard-monthly-user-count__container">
      <div className="de-wizard-monthly-user-count">
        <span className="de-wizard-monthly-user-count__label">Monthly User Count</span>
        <div
          className="de-200px-tooltip-wrap"
          data-tooltip-direction="top"
          data-tooltip-text="Monthly user count refers to the total global unique estIDs of all available data sources. As you add filters each step, the volume is expected to decrease."
          data-html="true"
        >
          <Icon type="outline" icon="idea" />
        </div>
      </div>
      <div className="de-wizard-monthly-user-count">
        <span className="de-wizard-monthly-user-count__value">
          {format('metric', totalUsers?.users || 0)}
        </span>
        <ProgressBar
          className="de-wizard-monthly-user-count__progress-bar"
          value={(totalUsers?.percent || 0) * 100}
        />
        <span className="de-wizard-monthly-user-count__progress-percentage">
          {twoNonZeroDecimals((totalUsers?.percent || 0) * 100)}%
        </span>
      </div>
    </div>
  )
}

export default MonthlyUserCount
